import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { AttributionTypeDTO, ProfileDTO, statusEnum } from '@app/user-profiles/model/user-profiles-model';
import { UserProfilesStore } from '@app/user-profiles/user-profiles-service/user-profiles-service.store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'scf-user-atributions',
  templateUrl: './user-atributions.component.html',
  styleUrls: ['./user-atributions.component.scss'],
})
export class UserAtributionsComponent implements OnInit {
  @Output() save = new EventEmitter<ProfileDTO>();
  @Output() update = new EventEmitter<ProfileDTO>();
  @Input() isUpdate: boolean = false;
  @Input() profileToUpdate: ProfileDTO;

  createProfileForm: FormGroup;
  displayedColumns: string[] = ['name', 'NO', 'YES', 'OPC'];
  selection = new SelectionModel<AttributionTypeDTO>(true, []);

  typeList: CommonDataDTO[] = [
    { id: 'S', value: 'SI' },
    { id: 'N', value: 'NO' },
  ];

  dataSource = new MatTableDataSource<AttributionTypeDTO>();
  data: AttributionTypeDTO[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public translateService: TranslateService,
    private userProfilesStore: UserProfilesStore,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.createProfileForm = this.formBuilder.group({
      name: ['', Validators.required],
      type: ['', Validators.required],
    });

    if (this.isUpdate && this.profileToUpdate) {
      this.createProfileForm.controls.name.setValue(this.profileToUpdate.name);
      this.createProfileForm.controls.type.setValue(this.profileToUpdate.typeBank);
      this.userProfilesStore.getProfile(this.profileToUpdate).subscribe((data: ProfileDTO) => {
        if (data) {
          this.dataSource.data = data.attributions;
        }
      });
    } else {
      this.userProfilesStore.getListAttributions().then((data) => (this.dataSource.data = data));
      this.createProfileForm.controls.type.setValue('N');
    }
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  saveUpdateProfile(update: boolean) {
    let profile: ProfileDTO = {
      id: update ? this.profileToUpdate.id : null,
      name: this.createProfileForm.value.name,
      typeBank: this.createProfileForm.value.type,
      attributions: this.selection.selected,
    };

    update ? this.update.emit(profile) : this.save.emit(profile);
  }

  selectionChecked(defaultSelect: any): boolean {
    if (defaultSelect) {
      return true;
    }
  }

  selectHandler(row: AttributionTypeDTO, option: string) {
    // delete row["groupCode"];
    // delete row["subGroupCode"];
    if (option === 'YES') {
      row.status = statusEnum.X;
    } else if (option === 'OPC') {
      row.status = statusEnum.P;
    } else if (option === 'NO') {
      row.status = statusEnum.N;
    }
    this.selection.select(row);
  }

  isCheckedOPT(row: AttributionTypeDTO): boolean {
    // delete row["groupCode"];
    // delete row["subGroupCode"];
    if (row.status == statusEnum.P) {
      this.selection.select(row);
      return true;
    }
    return false;
  }

  isCheckedYES(row: AttributionTypeDTO): boolean {
    // delete row["groupCode"];
    // delete row["subGroupCode"];
    if (row.status == statusEnum.X) {
      this.selection.select(row);
      return true;
    }
    return false;
  }
}
